<template>
  <footer class="footer">
    <div class="content has-text-centered container">
      <div id="terms-footer-container" class="level">
        <span
          class="level-item has-text-centered"
          v-for="(footerTerm, indx) in footerTerms"
          :key="footerTerm.nid"
        >
          <a class="vs" @click="viewTerms(indx)">{{ footerTerm.title }} </a>
        </span>
        <span
          class="level-item has-text-centered"
          v-for="extralink in extraLinks"
          :key="extralink.url"
        >
          <a class="vs" :href="extralink.url">{{ extralink.text }} </a>
        </span>
      </div>
      <p class="" v-html="getText('footer.extra_text')"></p>
      <p
        class=""
        v-html="getText('footer.copyright') + ' ' + new Date().getFullYear()"
      ></p>
    </div>
    <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <div class="modal-card">
        <section class="modal-card-body">
          <TermsText :htmltext="currentLongText"> </TermsText>
        </section>
        <footer class="modal-card-foot">
          <button class="button" v-on:click="closeModal">Cerrar</button>
        </footer>
      </div>
    </b-modal>
  </footer>
</template>
<script>
import { ToolsMixin } from '../mixins/ToolsMixin'
import TermsText from '../UI/TermsText.vue'

export default {
  components: {
    TermsText
  },
  mixins: [ToolsMixin],
  name: 'FooterBar',
  data: () => ({
    currentLongText: '',
    currentReadText: -1,
    isComponentModalActive: false
  }),
  methods: {
    viewTerms(indx) {
      this.currentLongText = this.footerTerms[indx].body
      this.currentReadText = indx
      this.isComponentModalActive = true
    },
    closeModal() {
      this.isComponentModalActive = false
    }
  },
  computed: {
    footerTerms() {
      return this.$store.state.register.productTerms
    },
    extraLinks() {
      if (this.$store.state.decoupled.configFile.texts.footer.links)
        return this.$store.state.decoupled.configFile.texts.footer.links
      else return []
    }
  },
  created() {
    this.$store.dispatch('register/getProductTerms')
    // this.$store.dispatch('register/getGlobalTerms')
  }
}
</script>
<style lang="css" scoped>
#terms_footer_container {
  display: flex;
  flex-wrap: wrap;
  line-height: 2em;
}
</style>
